<div>
  <h1>{{ greeting }}, {{ firstName() }}!</h1>
</div>
<lib-program-tiles [title]="'Start A Quote'" [icon]="'file-invoice-dollar'" (onTileSelect)="handleTileSelect($event)"></lib-program-tiles>
